import React, { useEffect, useRef } from 'react';

function MapComponent({ accommodation_id, map_position }) {
  const mapRef = useRef(null);

  useEffect(() => {
    if (!map_position) return;

    const parts = map_position.split(',').map(p => parseFloat(p.trim()));
    const lat = parts[0];
    const lng = parts[1];

    if (isNaN(lat) || isNaN(lng)) return;

    let isMounted = true;
    let intervalId = null;
    let mapInstance = null;
    let markerInstance = null;

    const initMap = () => {
      if (!isMounted || !mapRef.current) return;
      if (!window.google || !window.google.maps || !window.google.maps.Map) return;

      try {
        mapInstance = new window.google.maps.Map(mapRef.current, {
          center: { lat, lng },
          zoom: 15,
        });

        markerInstance = new window.google.maps.Marker({
          position: { lat, lng },
          map: mapInstance,
          title: 'Ubicación',
        });
      } catch (err) {
        console.error('Error initializing map:', err);
      }
    };

    if (window.google && window.google.maps && window.google.maps.Map) {
      initMap();
    } else {
      intervalId = setInterval(() => {
        if (window.google && window.google.maps && window.google.maps.Map) {
          if (intervalId) clearInterval(intervalId);
          initMap();
        }
      }, 500);
    }

    return () => {
      isMounted = false;
      if (intervalId) clearInterval(intervalId);
      if (markerInstance && markerInstance.setMap) {
        markerInstance.setMap(null);
      }
      if (window.google && window.google.maps && window.google.maps.event && mapInstance) {
        window.google.maps.event.clearInstanceListeners(mapInstance);
      }
    };
  }, [accommodation_id, map_position]);

  return (
    <div
      ref={mapRef}
      id={`map_${accommodation_id}`}
      style={{ height: '300px', width: '100%', minHeight: '300px' }}
    />
  );
}

export default MapComponent;
